const stateUrls = {
    fetchStates: {
        url: '/state'
    },
    fetchState: {
        url: '/state/:id'
    },
    fetchStatePositions: {
        url: '/state/:id/positions'
    },
    
};
export default stateUrls;